module.exports = __webpack_public_path__ + "img/img-8.a439a428.png";